export default {
    noNewsletters: "Zurzeit gibt es keine aktive Newsletter",
    subscribe: "Jetzt abonnieren"
}